<template>
  <div class="container">
    <el-row type="flex" justify="center">
      <el-col :xs="22" :sm="22" :md="15" :lg="12" :xl="10" id="center">
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="18">
            <div>
              <h2 style="text-align:center">首次登录，请修改您的密码</h2>
              <el-form :model="passForm" ref="passForm" label-position="left" :rules="rules" label-width="50px"
                class="demo-ruleForm" style="padding-top:0;margin-top:0">
                <el-form-item prop="oldpass">
                  <el-input type="password" v-model="passForm.oldpass" auto-complete="off" placeholder="输入原密码"
                    clearable></el-input>
                </el-form-item>
                <el-form-item prop="newpass">
                  <el-input type="password" v-model="passForm.newpass" auto-complete="off" placeholder="输入新密码"
                    clearable></el-input>
                </el-form-item>
                <el-form-item prop="repass">
                  <el-input type="password" v-model="passForm.repass" auto-complete="off" placeholder="确认新密码" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button style="width:100%" @click="submitPassForm('passForm')">确定</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { editPass } from '@/api/Login';

export default {
  data() {
    // 修改密码验证
    const validatePass0 = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入原始密码'));
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.passForm.newpass !== 'code') {
          this.$refs.passForm.validateField('repass');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'));
      } else if (value !== this.passForm.newpass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      }
      callback();
    };
    return {
      passForm: {
        oldpass: '',
        newpass: '',
        repass: '',
        check: '',

      },
      rules: {
        oldpass: [
          { validator: validatePass0, trigger: 'blur' },
        ],
        newpass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        repass: [
          { validator: validatePass2, trigger: 'blur' },
        ],
        check: [
          { validator: validateCheck, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 修改密码
    submitPassForm(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = { // http请求的参数
                NEW_PASSWORD: this.passForm.newpass,
                OLD_PASSWORD: this.passForm.oldpass,
              };
              editPass(data).then((res) => {
                this.$router.push({ path: '/' });
                this.$message.show({
                  text: '修改成功，重新返回登录',
                  type: 'success',
                });
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({
                  text: error,
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              console.log('error submit!!');
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
};
</script>
<style>
#center {
  margin-top: 10%;
  padding-top: 50px;
  padding-bottom: 50px;
  background: url('../assets/images/center.png') no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.container {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0;
  padding: 0;
  background: url('../assets/images/background1.jpg');
  /* background: url('../assets/images/background.png') no-repeat center center !important; */
}

.el-form {
  margin-right: 50px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>




// WEBPACK FOOTER //
// src/components/loginEditPass.vue